import { useEffect, useState } from 'react';

/**
 * Модальное подтверждение действий с доступом: предупреждение, опционально причина (обязательная) и комментарий.
 */
function AccessWarningModal({
  open,
  onClose,
  title,
  warning,
  reasonRequired = false,
  reasonLabel = 'Причина',
  reasonPlaceholder = '',
  showOptionalMessage = false,
  optionalMessageLabel = 'Комментарий (необязательно)',
  confirmLabel = 'Подтвердить',
  confirmButtonClass = 'btn-danger',
  onConfirm,
}) {
  const [reason, setReason] = useState('');
  const [optionalMessage, setOptionalMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState('');

  useEffect(() => {
    if (open) {
      setReason('');
      setOptionalMessage('');
      setLocalError('');
      setSubmitting(false);
    }
  }, [open]);

  if (!open) {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLocalError('');
    if (reasonRequired && !reason.trim()) {
      setLocalError('Укажите причину.');
      return;
    }
    try {
      setSubmitting(true);
      await onConfirm({
        reason: reason.trim(),
        optionalMessage: optionalMessage.trim(),
      });
      onClose();
    } catch (err) {
      setLocalError(err.message || 'Не удалось выполнить действие');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="modal-backdrop fade show modal-backdrop-stacked"
        aria-hidden="true"
        onClick={() => !submitting && onClose()}
      />
      <div
        className="modal fade show d-block modal-stacked"
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Закрыть"
                  disabled={submitting}
                  onClick={onClose}
                />
              </div>
              <div className="modal-body">
                <div className="alert alert-warning mb-3" role="alert">
                  {warning}
                </div>
                {reasonRequired && (
                  <div className="mb-3">
                    <label className="form-label" htmlFor="access-modal-reason">
                      {reasonLabel}
                      <span className="text-danger"> *</span>
                    </label>
                    <textarea
                      id="access-modal-reason"
                      className="form-control"
                      rows={3}
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      placeholder={reasonPlaceholder}
                      disabled={submitting}
                      required
                    />
                  </div>
                )}
                {showOptionalMessage && (
                  <div className="mb-0">
                    <label className="form-label" htmlFor="access-modal-optional">
                      {optionalMessageLabel}
                    </label>
                    <textarea
                      id="access-modal-optional"
                      className="form-control"
                      rows={2}
                      value={optionalMessage}
                      onChange={(e) => setOptionalMessage(e.target.value)}
                      disabled={submitting}
                    />
                  </div>
                )}
                {localError && <div className="alert alert-danger mt-3 mb-0">{localError}</div>}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline-secondary" disabled={submitting} onClick={onClose}>
                  Отмена
                </button>
                <button type="submit" className={`btn ${confirmButtonClass}`} disabled={submitting}>
                  {submitting ? 'Подождите…' : confirmLabel}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AccessWarningModal;
